/**
 * Copyright (c) Formium, Inc. and its affiliates.
 *
 * This source code is licensed under the Business Source License found in the
 * LICENSE file in the root directory of this source tree.
 */
/**
 *
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 *
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { FormElementAction } from './FormElementAction';
/* eslint-disable @typescript-eslint/consistent-type-assertions */

/**
 * Form element interface. This is a polymorphic interface that is the union of all possible element options within a given schema.
 *
 * @public
 */

export interface FormElement {
  /**
   * Unique identifier
   */
  id: string;

  /**
   * Title of element
   */
  title?: string;

  /**
   * Administrative slug
   */
  slug: string;

  /**
   * Element type
   */
  type: FormElementType;

  /**
   * Is the element required?
   */
  required?: boolean;

  /**
   * Custom error text when empty, but required
   */
  requiredText?: string;

  /**
   * Is the element hidden (initially)?
   */
  hidden?: boolean;

  /**
   * Can the field be dynamically populated via URL query?
   */
  dynamic?: boolean;

  /**
   * The name of the dynamic parameter (URL query parameter)
   */
  dynamicParam?: string;

  /**
   * The input placeholder (if applicable)
   */
  placeholder?: string;

  /**
   * Minimum value allowed in the answer, must be a positive integer.
   */
  minValue?: number;

  /**
   * Minimum number of characters allowed in the answer, must be a positive integer.
   */
  minLength?: number;

  /**
   * Initial value of the element. Does not apply to choice elements.
   */
  defaultValue?: string;

  /**
   * Maximum value allowed in the answer, must be a positive integer.
   */
  maxValue?: number;

  /**
   * Maximum number of characters allowed in the answer, must be a positive integer.
   */
  maxLength?: number;

  /**
   * The element description
   */
  description?: string;

  /**
   * Should randomize options?
   * @deprecated
   */
  randomize?: boolean;

  /**
   * Allow an other option in list. Only applies to choice or select options.
   * @deprecated
   */
  allowOther?: boolean;

  /**
   * The list of child element ids belonging to this element.
   * For a page element, these would be ids of elements. For a
   * Radio field, these would be the list of choice ids.
   */
  items?: Array<string>;

  /**
   * The list of logic actions for this element.
   */
  actions?: Array<FormElementAction>;

  /**
   * The set of allowed upload types
   */
  uploadTypes?: Array<FormElementUploadTypes>;
}

export enum FormElementType {
  DATE = <any>'DATE',
  EMAIL = <any>'EMAIL',
  FILE = <any>'FILE',
  LONG_TEXT = <any>'LONG_TEXT',
  NUMBER = <any>'NUMBER',
  PHONE_NUMBER = <any>'PHONE_NUMBER',
  SHORT_TEXT = <any>'SHORT_TEXT',
  TIME = <any>'TIME',
  URL = <any>'URL',
  CHOICE = <any>'CHOICE',
  RADIO = <any>'RADIO',
  BOOLEAN = <any>'BOOLEAN',
  CHECKBOX = <any>'CHECKBOX',
  PAGE = <any>'PAGE',
  GROUP = <any>'GROUP',
  STAR_RATING = <any>'STAR_RATING',
  NPS = <any>'NPS',
  HIDDEN = <any>'HIDDEN',
  DROPDOWN = <any>'DROPDOWN',
  PAYMENT = <any>'PAYMENT',
}
export enum FormElementUploadTypes {
  JPG = <any>'JPG',
  GIF = <any>'GIF',
  PNG = <any>'PNG',
  PDF = <any>'PDF',
  DOC = <any>'DOC',
  DOCX = <any>'DOCX',
  XLS = <any>'XLS',
  XLSX = <any>'XLSX',
  PPT = <any>'PPT',
  PPTX = <any>'PPTX',
}
